import { render, staticRenderFns } from "./EditUserPermissions.html?vue&type=template&id=86e88cbe&external"
import script from "./EditUserPermissions.vue?vue&type=script&lang=js"
export * from "./EditUserPermissions.vue?vue&type=script&lang=js"
import style0 from "./EditUserPermissions.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports